import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AuthService } from './auth.service';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { LoginRegisterService } from '../login-register/login-register.service';

@Injectable()

export class TokenInterceptor implements HttpInterceptor {

  constructor(
    public authService: AuthService,
    private router: Router,
    private loginRegisterService: LoginRegisterService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let authReq = req;
    if (token) {
      authReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const requestUrl = (authReq.url || '').toLowerCase();
          const currentUrl = (this.router.url || '').toLowerCase();

          // Do not redirect for explicit candidate login attempts; allow component to show inline errors
          const isCandidateLoginAttempt = requestUrl.includes('/candidate/login');
          if (isCandidateLoginAttempt) {
            return throwError(error);
          }

          // Use centralized session cleanup method
          this.loginRegisterService.clearSessionData();

          // If user is in candidate flow, redirect back to candidate login page instead of enterprise login
          const isInCandidateFlow = currentUrl.startsWith('/candidate');
          if (isInCandidateFlow) {
            if (currentUrl !== '/candidate') {
              this.router.navigate(['/candidate']);
            }
          } else if (!currentUrl.includes('/login')) {
            // Redirect to enterprise login if not already there
            this.router.navigate(['/login']);
          }

          // Optional token refresh flow can be added here if needed
        }
        return throwError(error);
      })
    );
  }

}
